import { FontIcon } from '@fluentui/react';
import { FC } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  width: 1em;
  height: 1em;

  user-select: none;
`;

const Icon = styled(FontIcon) <{ useBackgroundColor: boolean | undefined; color: string | undefined; fontSize: number | undefined; leftPercent: number; topPercent: number }>`
  position: absolute;

  color: ${p => p.useBackgroundColor ? p.theme.palette.white : p.color};
  font-size: ${p => p.fontSize ? `${p.fontSize}em` : undefined};
  left: ${p => p.leftPercent}%;
  top: ${p => p.topPercent}%;
`;

export interface IconProps {
    iconName: string;
    useBackgroundColor?: boolean;
    color?: string;
    size?: number;
    positionX?: number;
    positionY?: number;
}

interface IProps {
    icons: IconProps[];
    fontSize?: string | number;
    style?: React.CSSProperties;
    iconStyle?: React.CSSProperties;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const LayeredIcons: FC<IProps> = ({ icons, fontSize, style, iconStyle = {}, onClick }) => {

    return (
        <Container style={{ ...style, fontSize }} onClick={onClick}>
            {
                icons.map(({ iconName, color, useBackgroundColor, size = 1, positionX = 0.5, positionY = 0.5 }, i) =>
                    <Icon
                        key={`${i}-${iconName}`}
                        iconName={iconName}
                        useBackgroundColor={useBackgroundColor}
                        color={color}
                        fontSize={size}
                        leftPercent={(positionX - size / 2) * 100}
                        topPercent={(positionY - size / 2) * 100}
                        style={iconStyle}
                    />,
                )
            }
        </Container>
    );
};

export default LayeredIcons;